import {get, each} from 'lodash';
import schema from './product_db';
import * as utils from "./utils";
import moment from 'moment';
import {edit} from './sample';
import i18n from 'src/i18n/index';
import * as Group from './group';
import debug from '../debug';

export function title(model) {
  let title = i18n.S(get(model, 'details.title'));
  if (title) return title;
  let gp = get(model, 'required_groups.0.group');
  gp = gp ? Group.title.call(this, gp, Group) : null;
  return gp || i18n.s('schema.product');
}

export const columns = utils.columnsFn(schema);

export const list = utils.listFn('getProducts');
export const view = utils.viewFn('/admin/products/:id');
export const read = utils.readFn('getProductById', 'product_id', null, null, function (p) {
  return p.then(response => {
    if (!response.body) {
      throw new Error(i18n.f('alert.empty_response', {response}));
    }
    let result = response.body;
    if (!result.success) {
      console.error(response);
      return Promise.reject(i18n.S(result.err));
    }
    if (!result.data) {
      console.error(response);
      throw new Error(i18n.f('alert.invalid_response', {response}));
    }
    each(result.data.customs, x => {
      let str = x.custom_id.replace(/\.[a-z0-9\-]{36}$/i, '').split('-');
      x.details.start_time = moment(str[1], 'HHmm');
      x.details.cooldown_hours = parseFloat(str[2]) / 60;
      x.details.service_hours = parseFloat(str[0]) / 60;
    });
    return result.data;
  });
});
export const create = utils.createFn('/admin/products/create');

export {edit};

export function formActions(model, schema, readonly) {
  let temp = [];
  if (!readonly) {
    if (!this.$route.params.id) {
      temp.push({
        label: i18n.fr('action.create'),
        class: 'btn-success',
        validation: true,
        action: utils.updateFn('createProduct', null, [
          'type',
          'tags',
          'inventory_unlimited',
          'inventory',
          'required_custom_types',
          'required_groups',
          'customs',
          'details',
        ], function (payload, schema, columns) {
          each(payload.customs, x => {
            x.custom_id = `${x.details.service_hours * 60}-${moment(x.details.start_time).format('HHmm')}-${x.details.cooldown_hours * 60}`;
          });
          return payload;
        }),
      });
    } else {
      temp.push({
        label: i18n.fr('action.save') + ' [Ctrl+Enter]',
        class: 'btn-success',
        validation: true,
        trigger: e => (e.metaKey || e.ctrlKey) && e.keyCode === 13,
        action: utils.updateFn('updateProduct', 'product_id', [
          'type',
          'status',
          'tags',
          'inventory_unlimited',
          'inventory',
          'privacy',
          'required_custom_types',
          'required_groups',
          'customs',
          'details',
        ], function (payload, schema, columns) {
          for (let x of  payload.customs) {
            x.custom_id = `${x.details.service_hours * 60}-${moment(x.details.start_time).format('HHmm')}-${x.details.cooldown_hours * 60}`;
          }
          return payload;
        }),
      });
      temp.push({
        label: i18n.fr('action.duplicate'),
        class: 'btn-info',
        validation: true,
        action: utils.updateFn('duplicateProduct', 'product_id', [], null, null,
          utils.formActions.postprocess.redirect(result => `/admin/products/${result.data.product_id}`)),
      });
      if (debug.DEBUG) {
        temp.push({
          label: i18n.s('action.delete') + ' [Del]',
          class: 'btn-danger',
          trigger: e => e.keyCode === 46,
          action: utils.formActions.delete('deleteProductById', 'product_id', '/admin/products'),
        });
      }
    }
  }
  temp.push(utils.formActions.back);
  return temp;
}



// WEBPACK FOOTER //
// ./src/schemas/product.js